import { DialogActions, DialogContent } from "@mui/material";
import DialogHESP from "../DialogHESP/DialogHESP";
import { SdiInput } from "./TLADatacenterDeviceContextSdiInputs";
import DialogFooterWithLoading from "../Loading/DialogFooterWithLoading";

interface Props {
    open: boolean;
    onClose: () => void;
    sdiInput: SdiInput;
    onConfirm: () => void;
}

export default function ConfirmDeletDeviceContextSdiInput({ onClose, onConfirm, open, sdiInput }: Props) {
    return (
        <DialogHESP
            title={"Confirm remove "}
            open={open}
            onClose={onClose}
            content={
                <>
                    <DialogContent>Are you sure you want to remove SDI input "{sdiInput.name}"</DialogContent>
                    <DialogActions>
                        <DialogFooterWithLoading
                            isLoading={false}
                            loadingText="Delete"
                            onCancelClick={onClose}
                            defaultText={"Delete"}
                            onActionClick={onConfirm}
                        />
                    </DialogActions>
                </>
            }
        />
    );
}
